<template>
    <div class="fourSymbolsLineDiagram">
        <div ref="chartEl" :id="'ElephantLine_' + id_type" class="ElephantLine"></div>
    </div>
</template>

<script>
import {
    buildMarkLineData,
    resolveQuadrantConfig,
    scalePoint,
    resolveAxisExtent,
} from './quadrantGradeAxis';

const SCATTER_DOT_SIZE = 6;

const MARK_LINE = {
    symbol: ['none', 'arrow'],
    silent: true,
    lineStyle: { type: 'solid', width: 1, color: '#333' },
};

function formatScatterTooltip(params) {
    const { data } = params;
    const name = data.user_name || data.name || '';
    const effort = Number(data.value[0]).toFixed(2);
    const talent = Number(data.value[1]).toFixed(2);
    return `姓名: ${name}<br/>努力: ${effort}<br/>天赋: ${talent}`;
}

export default {
    props: ['id_type', 'ownexamData', 'GradeValue'],
    data() {
        return {
            chartInstance: null,
            resizeHandler: null,
        };
    },
    computed: {
        gradeValue() {
            const v = this.GradeValue;
            return v != null && v !== '' ? v : null;
        },
        quadrantConfig() {
            return resolveQuadrantConfig(this.gradeValue);
        },
        examList() {
            return Array.isArray(this.ownexamData) ? this.ownexamData : [];
        },
        scatterData() {
            const grade = this.gradeValue;
            return this.examList.reduce((acc, item) => {
                const scaled = scalePoint(item.x, item.y, grade);
                if (!scaled) return acc;
                const name = item.user_name || item.name || '';
                acc.push({
                    value: [scaled.x, scaled.y],
                    itemId: item.test_id,
                    user_name: name,
                    name,
                    createAt: item.create_at,
                    symbolSize: SCATTER_DOT_SIZE,
                    itemStyle: {
                        color: '#5470C6',
                        borderColor: '#fff',
                        borderWidth: 0,
                    },
                });
                return acc;
            }, []);
        },
        chartOption() {
            const list = this.examList;
            if (!list.length) return null;

            const { axisX, axisY } = this.quadrantConfig;
            const { min, max } = resolveAxisExtent(this.scatterData, axisX, axisY);
            const valueAxis = {
                type: 'value',
                min,
                max,
                axisLine: { onZero: false },
                splitLine: { show: false },
                interval: 10,
            };
            const first = list[0];
            return {
                title: {
                    text: (first && first.exam_name) || '',
                    left: 'center',
                    textStyle: { fontWeight: 'normal', fontSize: 13 },
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: formatScatterTooltip,
                    position: 'right',
                },
                dataZoom: [{ type: 'inside', startValue: min, endValue: max }],
                grid: { left: '15%', right: '15%' },
                xAxis: { ...valueAxis },
                yAxis: { ...valueAxis },
                series: [{
                    type: 'scatter',
                    data: this.scatterData,
                    symbol: 'circle',
                    symbolSize: SCATTER_DOT_SIZE,
                    markLine: {
                        ...MARK_LINE,
                        data: buildMarkLineData(axisX, axisY),
                    },
                }],
            };
        },
    },
    watch: {
        ownexamData: { handler: 'scheduleInitChart', deep: true },
        GradeValue: 'scheduleInitChart',
    },
    mounted() {
        this.scheduleInitChart();
    },
    beforeDestroy() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = null;
        }
        this.disposeChart();
    },
    methods: {
        scheduleInitChart() {
            this.$nextTick(() => this.initChart());
        },
        disposeChart() {
            if (!this.chartInstance) return;
            try {
                this.chartInstance.dispose();
            } catch (e) {
                /* 容器已卸载时可能抛错 */
            }
            this.chartInstance = null;
        },
        bindResizeOnce() {
            if (this.resizeHandler) return;
            this.resizeHandler = () => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            };
            window.addEventListener('resize', this.resizeHandler);
        },
        initChart() {
            const el = this.$refs.chartEl;
            if (!el) return;

            const option = this.chartOption;
            if (!option) {
                this.disposeChart();
                return;
            }

            if (!this.chartInstance) {
                this.chartInstance = this.$echarts.init(el);
                this.bindResizeOnce();
            }
            this.chartInstance.setOption(option, true);
            this.$nextTick(() => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            });
        },
    },
};
</script>

<style scoped lang="less">
.fourSymbolsLineDiagram {
    width: 100%;
    height: 100%;

    .ElephantLine {
        width: 100%;
        height: 100%;
    }
}
</style>
